import Joi from "joi";

// Define the Joi schema
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const signUpSchema = Joi.object({
  name: Joi.string()
    .trim() // Removes leading and trailing spaces
    .pattern(/^[a-zA-Z]*(\s[a-zA-Z]*)+$/) // Updated regex pattern
    .required() // Name is required
    .messages({
      "string.base": "Name should be a type of text",
      "string.empty": "Name cannot be empty",
      "string.pattern.base":
        "Full Name must consist of first and last name seperated by space.",
      "any.required": "Name is required",
    }),

  email: Joi.string()
    .email({ tlds: { allow: false } })
    .pattern(emailRegex)
    .max(40)
    .required()
    .messages({
      "string.empty": "Email is required",
      "string.email": "Invalid email format",
    }),
  phone: Joi.string()
    .pattern(/^\d{10}$/) // Matches exactly 10 digits
    .required()
    .messages({
      "string.pattern.base": "Mobile number must be a 10-digit number.",
      "any.required": "Mobile number is required.",
    })
    .required(),

  password: Joi.string()
    .min(8) // Minimum 8 characters
    .max(16) // Optional: Set a maximum limit if needed (e.g., 20 characters)
    .regex(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^-_&*])[A-Za-z\d!@#$%^&*-_]+$/) // At least one letter and one number
    .required()
    .messages({
      "string.base": "Password must be a string.",
      "string.empty": "Password cannot be empty.",
      "string.min": "Password must be at least 8 characters long.",
      "string.max": "Password cannot exceed 20 characters.",
      "string.pattern.base":
        "Password must contain at least one letter, one number, and one special character.",
      "any.required": "Password is required.",
    }),

  confirmPassword: Joi.string().valid(Joi.ref("password")).required().messages({
    "string.empty": "Confirm Password is required",
    "any.only": "Passwords do not match",
  }),
});

export default signUpSchema;
